import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { scaffolderReactTranslationRef } from '@backstage/plugin-scaffolder-react/alpha';

export const scaffolderReactTranslation = TranslationBlueprint.make({
  name: 'scaffolder-react',
  params: {
    resource: createTranslationMessages({
      ref: scaffolderReactTranslationRef,
      full: false,
      messages: {
        'passwordWidget.content':
          'Deze widget is onveilig. Gebruik [`ui:field: Secret`](https://backstage.io/docs/features/software-templates/writing-templates/#using-secrets) in plaats van `ui:widget: password`',
        'scaffolderPageContextMenu.moreLabel': 'meer',
        'scaffolderPageContextMenu.createLabel': 'Aan de slag',
        'scaffolderPageContextMenu.editorLabel': 'Beheer templates',
        'scaffolderPageContextMenu.actionsLabel': 'Geïnstalleerde acties',
        'scaffolderPageContextMenu.tasksLabel': 'Takenlijst',
        'scaffolderPageContextMenu.templatingExtensionsLabel':
          'Template-extensies',
        'stepper.backButtonText': 'Terug',
        'stepper.createButtonText': 'Maak aan',
        'stepper.reviewButtonText': 'Controleer',
        'stepper.stepIndexLabel': 'Stap {{index, number}}',
        'stepper.nextButtonText': 'Volgende',
        'templateCategoryPicker.title': 'Categorieën',
        'templateCard.noDescription': 'Geen beschrijving',
        'templateCard.chooseButtonText': 'Kies',
        'cardHeader.detailBtnTitle': 'Toon details van template-entiteit',
        'templateOutputs.title': 'Tekstuitvoer',
        'workflow.noDescription': 'Geen beschrijving',
      },
    }),
  },
});
